import angular from 'angular';
import RbRfpManagerCompanies from './rfp-manager-companies/rfp-manager-companies.cmp';

export default angular.module('rb.rfp.rfpManager.main.ui',  [])
  .component('rbRfpManagerCompanies', RbRfpManagerCompanies)
